import React from "react";
import { useHistory } from "react-router";
import { Button, Col, DatePicker, Form, Row, Select } from "antd";
import type { FormProps } from "antd/es/form/Form";
import type { UploadFile } from "antd/lib/upload/interface";
import { displayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import "./UploadPrice.less";
import Dropzone from "../Dropzone/Dropzone";
import moment from "moment";
import { useAppSelector } from "../..";
import { getSelectOptions } from "../../lib/utils";
import { ImportPriceData } from "../../lib/types/ImportPriceData";
import LocalStorageService from "../../services/LocalStorageService";

interface UploadPriceProps {
  uploadPriceSubmit: (importPriceData: ImportPriceData) => void;
  agreementId: number;
  accountId: number;
}

export const UploadPrice = (props: UploadPriceProps) => {
  const { uploadPriceSubmit, accountId, agreementId } = props;
  const history = useHistory();
  const { agreements } = useAppSelector((state) => state.agreements);
  const { account } = useAppSelector((state) => state.accounts);
  const { priceTemplates } = useAppSelector((state) => state.individualTariffs);
  const { dicCurrencies } = useAppSelector((state) => state.rtkDictionaries);
  const { offerList } = useAppSelector((state) => state.offering);

  const [form] = Form.useForm();

  const initialValues = {
    effectiveDate: moment().add(7, "day"),
    agreementId,
    accountId,
    validateMode: "Stop and Notify",
    // offeringId: 1,
  };

  const formLayout: FormProps = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 12,
    },
    labelAlign: "left",
  };

  const getBinaryFile = (file: UploadFile): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => {
        reader.abort();
        reject(new Error("Error parsing file"));
      };
      reader.onload = () => {
        const readerResult = reader.result as string;
        const result = readerResult.split(",")[1];
        resolve(result);
      };
      if (file.originFileObj) {
        reader.readAsDataURL(file.originFileObj);
      }
    });
  };

  const onFinish = async (values) => {
    const file: string = await getBinaryFile(values.file).then((value) => value);

    const tenantId = Number(LocalStorageService.getTenantId());

    uploadPriceSubmit({
      effectiveDate: toHttpFormatStartOfDay(values.effectiveDate),
      templateId: values.templateId,
      agreementId: values.agreementId,
      currencyId: values.currencyId,
      fileName: values.file.name,
      tenantId,
      accountId: values.accountId,
      offeringId: values.offeringId,
      content: {
        data: file,
        tenantId,
      },
    });
  };

  return (
    <div className="upload-price">
      <Form form={form} initialValues={initialValues} {...formLayout} onFinish={onFinish}>
        <Form.Item
          name="effectiveDate"
          label="Дата вступления изменений"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <DatePicker format={displayFormat} />
        </Form.Item>
        <Form.Item
          name="templateId"
          label="Шаблон"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <Select
            options={getSelectOptions({
              list: priceTemplates,
            })}
          />
        </Form.Item>
        <Form.Item
          name="accountId"
          label="Оператор"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <span>{account.organization.fullName}</span>
        </Form.Item>
        <Form.Item
          name="agreementId"
          label="Договор"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <Select
            options={getSelectOptions({
              list: agreements,
              labelName: "agreementNumber",
            })}
          />
        </Form.Item>
        <Form.Item
          name="offeringId"
          label="Продукт"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <Select
            options={
              offerList.length > 0
                ? getSelectOptions({
                    list: offerList,
                  })
                : getSelectOptions({
                    list: [{ id: 1, name: "Хардкод на фронте 1" }],
                  })
            }
          />
        </Form.Item>
        <Form.Item
          name="currencyId"
          label="Валюта"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <Select
            options={getSelectOptions({
              list: dicCurrencies,
            })}
          />
        </Form.Item>
        <Form.Item
          name="validateMode"
          label="Режим валидации"
          rules={[{ required: true }]}
          className="form-item-required__hidden-error"
        >
          <span>{form.getFieldValue("validateMode")}</span>
        </Form.Item>
        <Form.Item
          name="file"
          label="Файл"
          rules={[{ required: true, message: "Пожалуйста, выберите файл" }]}
        >
          <Dropzone
            updateFile={(file) => {
              form.setFieldsValue({ file });
            }}
            accept={["xlsx"]}
          />
        </Form.Item>
      </Form>
      <Row gutter={20} justify="center">
        <Col>
          <Button
            onClick={() => {
              history.push(`/accounts/${accountId}/agreements/${agreementId}/tariffs`);
            }}
            className="l-btn"
          >
            Назад
          </Button>
        </Col>
        <Col>
          <Button type="primary" onClick={form.submit} className="l-btn">
            Далее
          </Button>
        </Col>
      </Row>
    </div>
  );
};
